import {
    SETTINGS_SET_VALUE
} from '../../action-types';

const initialState = {
    showDate: true,
    showSite: true,
    showExcerpt: true,
    items: [
        {
            name: 'Show Date',
            setting: 'showDate'
        },
        {
            name: 'Show Excerpt',
            setting: 'showExcerpt'
        },
        {
            name: 'Show Site',
            setting: 'showSite'
        }
    ]
};

export default function settings( state = initialState, action ) {

    switch ( action.type ) {

        case SETTINGS_SET_VALUE:
            return Object.assign({}, state, {
                [action.key]: action.value
            });

        default:
            return state;

    }

}


/** WEBPACK FOOTER **
 ** ./src/state/reducers/settings/index.js
 **/